import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ISearchUser } from '@account-users/user/models/ISearchUser';

@Component({
  selector: 'app-user-bulk-edit',
  templateUrl: './user-bulk-edit.component.html',
  styleUrls: ['./user-bulk-edit.component.scss'],
})
export class UserBulkEditComponent {
  @Input() permissions: string[] = [];
  @Input() selectedUsers: ISearchUser[] = [];

  @Output() approveChangePermissions: EventEmitter<
    boolean
  > = new EventEmitter();
}
